import { Box, Stack } from '@customink/pigment-react';
import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import type React from 'react';
import { useCallback } from 'react';

import { LiveEngage } from '../LiveEngageLink';

import { googleAnalyticsTag } from '@/components/vendors/googleAnalytics';
import { LivePersonTaxExemptId } from '@/constants';

interface CSSPropertiesWithVars extends React.CSSProperties {
  '--typography-button-medium-size'?: string;
  '--typography-button-small-size'?: string;
}

const stylesWithVars: CSSPropertiesWithVars = {
  '--typography-button-medium-size': '16px',
  '--typography-button-small-size': '14px',
};
const taxExemptionsServiceNumber = '(855) 256-0225';

export function ChatWithUs() {
  const theme = useTheme();
  const isMdOrSmaller = useMediaQuery(theme.breakpoints.down('lg'));

  const trackChatClick = useCallback(() => {
    googleAnalyticsTag({
      event: 'click contact',
      click_section: 'tax exempt modal',
      click_link: 'chat',
    });
  }, []);
  const trackContactClick = useCallback(() => {
    googleAnalyticsTag({
      event: 'click contact',
      click_section: 'tax exempt modal',
      click_link: '855-256-0225',
    });
  }, []);

  if (isMdOrSmaller) {
    return (
      <LiveEngage
        liveEngageId={LivePersonTaxExemptId}
        onClick={trackChatClick}
        showChatIcon
        sx={{
          mr: 'auto',
          width: { sm: '100%', md: 'auto' },
          justifyContent: 'center',
          alignSelf: { sm: 'stretch', md: 'center' },
          py: 1,
        }}
      />
    );
  }

  return (
    <Stack
      direction="row"
      gap={1}
      style={stylesWithVars}
      sx={{ ml: '0', mr: 'auto' }}
    >
      <Box onClick={trackContactClick} sx={{ p: 1, pb: 0 }}>
        <customer-contact service-number={taxExemptionsServiceNumber} />
      </Box>
      {/*Use the web component from ci-header for visuals, but our LiveEngage for the functionality*/}
      <LiveEngage
        liveEngageId={LivePersonTaxExemptId}
        onClick={trackChatClick}
        sx={{ cursor: 'pointer', p: 1, pb: 0 }}
      >
        <customer-chat />
      </LiveEngage>
    </Stack>
  );
}
